import { render, staticRenderFns } from "./UserCreateDialog.vue?vue&type=template&id=b86ad5c8&scoped=true"
import script from "./UserCreateDialog.vue?vue&type=script&lang=ts"
export * from "./UserCreateDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b86ad5c8",
  null
  
)

export default component.exports